"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortArrayObject = void 0;
/**
 * Dynamic sort array object
 * @param key
 * @param order
 * @returns {function(...[*]=)}
 */
var sortArrayObject = function sortArrayObject(key) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
  return function (a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }
    var varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
    var varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];
    var comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === 'desc' ? comparison * -1 : comparison;
  };
};
exports.sortArrayObject = sortArrayObject;